import React from 'react';
import { useParams } from 'react-router-dom';

const StockDetail = () => {
  const { symbol } = useParams();

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container-custom">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">
          Stock Details: {symbol?.toUpperCase()}
        </h1>
        <div className="card">
          <div className="card-body">
            <p className="text-gray-600">Stock details will be displayed here when API keys are configured.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockDetail;
